let order_BillItemEdit = require("../../templates/order/BillItemEdit.handlebars");
let Backbone = require("backbone");
let _ = require("underscore");
import POS from "../../POS.js";
let MenuTagCollection = require("../../collection/MenuTagCollection.js");
let MenuTagModel = require("../../model/MenuTagModel.js");
let DiscountCollection = require("../../collection/DiscountCollection.js");

let main = function () {
    return Backbone.View.extend({
        events: {
            'click .closeBillItemEdit': "onClose",
            'click .menuTag': "switchTag",
            'click .discount': "switchDiscount"
        },

        initialize: function () {
            this.model = new Backbone.Model();
        },

        onClose: function () {
            this.trigger("close");
        },
        render: function () {
            //获得当前Item对应MenuItem和MenuCategory对应的所有Tag
            var selectedMenuItem = this.model.get("menuItem"),
                currrentMenuCategory = POS.getMenu().getCategories().get(selectedMenuItem.categoryId),
                currrentMenuItem = currrentMenuCategory.get("menuItems").get(selectedMenuItem.id);
            var allTags = new MenuTagCollection(),
                selectedTags = this.model.get("tags");
            var allDiscounts = new DiscountCollection(),
                self = this;
            $.each(POS.get("discountCollection").where({singe: true}), function (index, discount) {
                if (discount.canApplyTo(selectedMenuItem)) {
                    allDiscounts.add(discount);
                }
            });
            allTags.add(currrentMenuCategory.get("tags").toArray());
            allTags.add(currrentMenuItem.get("tags").toArray());
            //如果当前Item拥有选中的Tags，则设置其状态为选中
            if (selectedTags) {
                //为了不让MenuTag原始的Model被修改 ，clone新的Model用来标记选中的Tag
                var tempAllTags = allTags.clone();
                allTags.reset();
                tempAllTags.each(function (tag) {
                    var tempTag = tag.clone();
                    allTags.add(tempTag);
                    if (selectedTags.get(tag.get("id"))) {
                        tempTag.set("selected", true);
                    }
                });
            }
            if (self.model.get("discount")) {
                var tempAllDiscounts = allDiscounts.clone();
                allDiscounts.reset();
                tempAllDiscounts.each(function (discount) {
                    var tempDiscount = discount.clone();
                    allDiscounts.add(tempDiscount);
                    if (self.model.get("discount").id == tempDiscount.get("id")) {
                        tempDiscount.set("selected", true);
                    }
                });
            }

            var params = this.model.toJSON();
            params.tags = allTags.length > 0 ? allTags.toJSON() : false;
            params.discounts = allDiscounts.length > 0 ? allDiscounts.toJSON() : false;
            this.$el.find(".billItemEdit").remove();
            this.$el.append(order_BillItemEdit(params));
            return this;
        },
        addTagsToItem: function (menuTags) {
            $.each(this.selectedCollection.models, function (i, item) {
                item.set("tags", menuTags, {silent: true});
            });
        },
        addDiscountToItem: function (discount) {
            $.each(this.selectedCollection.models, function (i, item) {
                if (!discount) {
                    item.unset("discount");
                    return
                }
                item.set("discount", discount);
            });
        },
        /**
         * 加上或去掉单品折扣
         */
        switchDiscount: function (evt) {
            var selectDiscount = $(evt.target),
                self = this;
            selectDiscount.siblings(".discount").removeClass("selected");
            if (selectDiscount.hasClass("selected")) {
                selectDiscount.removeClass("selected");
                self.model.unset("discount");
                self.trigger("changeDiscount");
            } else {
                selectDiscount.addClass("selected");
                $.each(POS.get("discountCollection").models, function (index, discount) {
                    if (discount.get("singe") && discount.get("id") == selectDiscount.data("id")) {
                        discount = POS.get("discountCollection").get(discount.id);
                        self.model.set({discount: discount});
                        self.trigger("changeDiscount", self.model);
                    }
                });
            }
        },

        _addPackageTag: function (tagName, optionName) {
            console.log("add package tag!", tagName);
            const pItems = this.model.get("packageItems");
            const newItems = _.mapObject(pItems, function (item, name) {
                if (optionName === name) {
                    if (item.selectedTags) {
                        return _.extend(item, {selectedTags: item.selectedTags.concat(tagName)});
                    } else {
                        return _.extend(item, {selectedTags: [tagName]});
                    }

                } else {
                    return item;
                }
            });
            this.model.set("packageItems", newItems);
        },

        _removePackageTag: function (tagName, optionName) {
            const pItems = this.model.get("packageItems");
            const newItems = _.mapObject(pItems, function (item, name) {
                if (optionName === name) {
                    const selectedTags = item.selectedTags;
                    if (selectedTags) {
                        const index = selectedTags.indexOf(tagName);
                        if (index > -1) {
                            return _.extend(item, {selectedTags: item.selectedTags.splice(index + 1, 1)});
                        } else {
                            return item
                        }
                    } else {
                        return item;
                    }

                } else {
                    return item;
                }
            });
            this.model.set("packageItems", newItems);
        },

        /*
         * 加上或去掉Tag
         */
        switchTag: function (evt) {
            var menuTagCollection = this.model.get("tags");
            var selectdTagButton = $(evt.target), tagName = selectdTagButton.data('name');
            var tagMenuItem;

            //如果Tag是$开头，我们要找到相对于名字的menu item, 加入bill里
            if (tagName.substring(0, 1) == "$") {
                console.log('added a priced tag ', tagName);

                _.find(POS.getMenu().get('categories').models, function (cat) {
                    return _.find(cat.get('items'), function (item) {
                        if (('$' + item.name) == tagName) {
                            //want to break from here;
                            tagMenuItem = item;
                            return true;
                        } else {
                            return false;
                        }
                    });
                });

                if (tagMenuItem) {
                    tagMenuItem = _.pick(tagMenuItem, ['categoryId', 'name', 'price', 'id']);
                    tagMenuItem.menuItemId = tagMenuItem.id;
                    tagMenuItem.quantity = this.model.get('quantity');
                    tagMenuItem.billItemModelId = this.model.cid;
                    console.log('menu item is ', tagMenuItem);
                }
            }

            if (!menuTagCollection) {
                menuTagCollection = new MenuTagCollection();
                this.model.set({tags: menuTagCollection});
            }

            if (selectdTagButton.hasClass("selected")) {
                menuTagCollection.remove(menuTagCollection.get(selectdTagButton.data("id")));
                selectdTagButton.removeClass("selected");

                if (tagMenuItem) {
                    this.trigger("removeTagMenuItem", tagMenuItem);
                }

            } else {
                menuTagCollection.add(new MenuTagModel({
                    id: selectdTagButton.data("id"),
                    name: selectdTagButton.data("name")
                }));
                selectdTagButton.addClass("selected");

                if (tagMenuItem) {
                    this.trigger("selectMenuItem", tagMenuItem);
                }

            }
            this.trigger("changeTag");
        }
    });

};

let exportedValue = main();
export default exportedValue;


// WEBPACK FOOTER //
// ./src/view/order/BillItemEditView.js